import { Injectable } from '@angular/core';
import { MarkerClusterService } from './marker-cluster.service';
import { GoogleMapHTTPService } from 'src/app/modules/aa-core/services/google/google-map-http/google-map-http.service';
import { IGoogleMap, ILatLng, MarkerIcon } from 'src/app/core/models/google-map-models';
import { SummaryData } from 'src/app/modules/route-planner/models/route-summary-model';
import { ITrafficAlertCarkPark, IServiceTopHits } from 'src/app/core/models/models';
import { AAGoogleMarkerService } from 'src/app/modules/aa-core/services/google/google-marker/aa-google-marker.service';
import { AAGoogleIconService } from 'src/app/modules/aa-core/services/google/aa-google-icon/aagoogle-icon.service';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';
import { GoogleInfoWindowService } from '../google-info-window/google-info-window.service';
import { MapContextMenuEvents, GoogleMapEvents } from 'src/app/core/events/events';

@Injectable({
  providedIn: 'root'
})
export class ServiceStationMarkerService extends MarkerClusterService {

  constructor(private googleHttp: GoogleMapHTTPService,
    private googleIconManager: AAGoogleIconService,
    private googleInfoWindow: GoogleInfoWindowService,
    private appService: AppService,
    private aaMarkerService: AAGoogleMarkerService) {
    super();
   }

  private travelMarkers: Array<any> = [];
  private travelData: ITrafficAlertCarkPark[];

  private eventListerner: any;
  private googleMap: IGoogleMap;

   public loadTravelData(googleMap: IGoogleMap, selectedRoute: SummaryData): void {
    this.googleHttp.getServiceStation(selectedRoute.overviewPolyline).subscribe( data => {
      // console.log('Service Station ---> ', data);
      this.travelData = data;
      this.addTravelMarker(googleMap);
    });

  }

  public clear(): void {
    this.travelMarkers.forEach(marker => {
      marker.setMap(null);
    });
    this.travelMarkers = [];
  }

  private addRemoveMapEvent(googleMap): void {
    if (this.eventListerner) {
      google.maps.event.removeListener(this.eventListerner);
    }
    this.googleMap = googleMap;
    this.eventListerner = google.maps.event.addListener(googleMap, GoogleMapEvents.ZOOM_CHANGED, this.zoomChangeHandler);
  }

  private zoomChangeHandler = () => {
    const isNanoIcon = (this.googleMap.getZoom() < 8);

    this.travelMarkers.forEach( marker => {
      marker.setIcon( this.googleIconManager.getServiceStationIcon(isNanoIcon) );
    });
  }

  private addTravelMarker (googleMap: IGoogleMap): void {
    this.addRemoveMapEvent(googleMap);
    this.clear();
    for (let markerCounter = 0; markerCounter < this.travelData.length; markerCounter++) {
      const carParkModel: any = this.travelData[markerCounter]; // as ITrafficAlertCarkPark;
      this.createTravelMarker(carParkModel, googleMap);
    }
  }

  private createTravelMarker = (travelData: IServiceTopHits, googleMap: IGoogleMap) => {
    const icon: MarkerIcon = this.googleIconManager.getServiceStationIcon();

    const cpShape = {
      coord: [1, 1, 1, 30, 28, 30, 28, 1],
      type: 'poly'
    };

    const latLng: ILatLng = new google.maps.LatLng(travelData.lat, travelData.lon);
    const cpMarker = new google.maps.Marker({
      position: latLng,
      map: googleMap,
      icon: icon,
      title: travelData.address.formattedAddress || 'Service station',
      shape: cpShape,
      // shadow: IconShadow,
      html: this.getMarkerInfoWindowHtmlContent(travelData)
    });

    cpMarker.category = 'servicestation';
    cpMarker.data = travelData;
    // cpMarker.setVisible(this.googleMapOptions.CarPark);

    google.maps.event.addListener(cpMarker, 'click', () => {
      this.googleInfoWindow.close();
      this.googleInfoWindow.setContent(cpMarker.html);
      this.googleInfoWindow.open(googleMap, cpMarker);
    });
    this.travelMarkers.push(cpMarker);

    return cpMarker;
  }

  private getMarkerInfoWindowHtmlContent = (markerDataObj: any) => {
    // console.log('Popup Data:', markerDataObj);
    const fromDirection = `javascript:${MapContextMenuEvents.UPDATE_FROM_LOCATION}('', ${markerDataObj.lat}, ${markerDataObj.lon})`;
    const toDirection = `javascript:${MapContextMenuEvents.UPDATE_TO_LOCATION}('', ${markerDataObj.lat}, ${markerDataObj.lon})`;
    const fromRoute = `<a class="from_direction" href="${fromDirection}">from here</a>`;
    const toRoute = `<a class="to_direction" href="${toDirection}">to here</a>`;

    const $title: string = (markerDataObj.address?.formattedAddress)
      ? markerDataObj.address.formattedAddress : 'Service Station';

    const description = markerDataObj.description || '';

    // Info Map window html content
    return `<div class='iw-hotels' id='hotel-window'>
        <h3>${$title}</h3>
        <hr>
        <div>${description}</div>
        <div>Plan a new route ${fromRoute} or ${toRoute}</div>
      </div>`;
  }

}
